import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './main.component';
import {ParkingInfoComponent} from "../_shared/parking-info/parking-info.component";

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'kontakt',
        loadChildren: () =>
          import('./contact/contact.module').then((m) => m.ContactModule),
      },
      {
        path: 'restauracja',
        loadChildren: () =>
          import('./restaurant/restaurant.module').then(
            (m) => m.RestaurantModule
          ),
      },
      {
        path: 'vip',
        loadChildren: () =>
          import('./vip/vip.module').then(
            (m) => m.VipModule
          ),
      },
      {
        path: 'rezerwacje',
        loadChildren: () =>
          import('./reservations/reservations.module').then(
            (m) => m.ReservationsModule
          ),
      },
      {
        path: 'moja-rezerwacja',
        loadChildren: () =>
          import('./my-reservation/my-reservation.module').then(
            (m) => m.MyReservationModule
          ),
      },
      {
        path: 'menu',
        loadChildren: () =>
          import('./menu/menu.module').then(
            (m) => m.MenuModule
          ),
      },
      /*  {
       path: 'season-menu',
       loadChildren: () =>
         import('./season-menu/season-menu.module').then(
           (m) => m.SeasonMenuModule
         ),
     },
     {
         path: 'instrukcja-parkingu',
         loadChildren: () =>
           import('./parking-instruction/parking-instruction.module').then(
             (m) => m.ParkingInstructionModule
           ),
       }, {
         path: 'instrukcja-parkingu-kroki',
         component: ParkingInfoComponent
       },
    */
      {
        path: 'polityka-prywatności',
        loadChildren: () =>
          import('./privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'regulamin-rezerwacji',
        loadChildren: () =>
          import('./terms-of-reservation/terms-of-reservation.module').then(
            (m) => m.TermsOfReservationModule
          ),
      },
      {
        path: 'news',
        loadChildren: () =>
          import('./news/news.module').then(
            (m) => m.NewsModule
          ),
      },
      {
        path: 'promocje',
        loadChildren: () =>
          import('./promotion/promotion.module').then(
            (m) => m.PromotionModule
          ),
      },
      {
        path: '404',
        loadChildren: () =>
          import('./not-found/not-found.module').then((m) => m.NotFoundModule),
      },
      {
        path: '**',
        redirectTo: '404',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {
}
